import React from 'react';
import { ForgotPassword as AWSForgotPassword } from 'aws-amplify-react';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import AppLogo from 'components/theme/app-logo';
import { Typography } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    height: '100vh'
  },
  main: {
    maxWidth: 400,
    marginTop: -100
  },
  title: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  action: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 2
  }
});

class ForgotPassword extends AWSForgotPassword {
  sendView() {
    return (
      <TextField
        autoFocus
        required
        label="Username"
        key="username"
        name="username"
        placeholder="Enter your username"
        margin="normal"
        onChange={this.handleInputChange}
        fullWidth
        variant="outlined"
      />
    );
  }

  submitView() {
    return (
      <div>
        <TextField
          autoFocus
          required
          label="Code"
          key="code"
          name="code"
          placeholder="Enter code you received"
          autoComplete="off"
          margin="normal"
          onChange={this.handleInputChange}
          fullWidth
          variant="outlined"
        />
        <TextField
          required
          label="New Password"
          key="password"
          name="password"
          type="password"
          placeholder="Enter new password"
          autoComplete="new-password"
          margin="normal"
          onChange={this.handleInputChange}
          fullWidth
          variant="outlined"
        />
      </div>
    );
  }

  showComponent() {
    const { classes, authData = {} } = this.props;

    return (
      <>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="center"
          className={classes.root}
        >
          <Grid item xs={10} sm={5} className={classes.main}>
            <AppLogo />
            <Typography
              variant="h6"
              headlineMapping={{ h6: 'h1' }}
              className={classes.title}
            >
              Reset Password
            </Typography>

            {this.state.delivery || authData.username
              ? this.submitView()
              : this.sendView()}

            {this.state.delivery || authData.username ? (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.submit}
                disabled={this.state.loading}
                className={classes.action}
                data-testid="btn-forgot-password"
              >
                Submit
              </Button>
            ) : (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.send}
                disabled={this.state.loading}
                className={classes.action}
                data-testid="btn-send-code"
              >
                Send Code
              </Button>
            )}

            {this.state.delivery || authData.username ? (
              <Link
                component="button"
                variant="body2"
                onClick={this.send}
                data-testid="link-resend-code"
                className={classes.action}
              >
                Resend Code
              </Link>
            ) : (
              <Link
                component="button"
                variant="body2"
                onClick={() => this.changeState('signIn')}
                data-testid="link-back-to-sign-in"
                className={classes.action}
              >
                Back to Sign In
              </Link>
            )}
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ForgotPassword);
